import { useEffect, useState } from 'react';

import compileGoogleFontsUrl from '../../helpers/url/compileGoogleFontsUrl';

const createLink = (fonts: Array<string>) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = compileGoogleFontsUrl(fonts);

    return link;
};

const useGoogleFonts = (fonts: Array<string>) => {
    const [link, setLink] = useState(() => createLink(fonts));

    useEffect(() => {
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, [link]);

    useEffect(() => {
        setLink(createLink(fonts));
    }, fonts);

    return null;
};

export default useGoogleFonts;
